import React, { FC, useEffect } from 'react';

import { provider, ProductEnvironment } from '@atlassian/forge-ui';

import { HostedResourceContainer } from './styled';

type Props = {
  onInitialRender?: () => void;
  environment: ProductEnvironment;
};

export const HostedResourceWrapper: FC<Props> = ({
  children,
  onInitialRender,
  environment,
}) => {
  useEffect(() => {
    if (onInitialRender) {
      onInitialRender();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <provider.ForgeUIEnvironmentProvider value={environment}>
      <HostedResourceContainer>{children}</HostedResourceContainer>
    </provider.ForgeUIEnvironmentProvider>
  );
};
